import { useMemo } from 'react';
import {
  useGetTypeCategoryAndTags,
  convertTagDocsDataToOptions,
} from '../../../../../../../DynamicTagsInputs/utils';

export const useTagData = (tagTypesConfig = []) => {

  const hasThemes = tagTypesConfig.some(t => t.tagType === 'themes');
  const hasSubThemes = tagTypesConfig.some(t => t.tagType === 'subThemes');
  const hasTags = tagTypesConfig.some(t => t.tagType === 'tags');

  const themesQuery = useGetTypeCategoryAndTags({ 
    tagTypeProp: hasThemes ? 'themes' : null, 
    enableDataFetch: hasThemes 
  });
  const subThemesQuery = useGetTypeCategoryAndTags({ 
    tagTypeProp: hasSubThemes ? 'subThemes' : null, 
    enableDataFetch: hasSubThemes 
  });
  const tagsQuery = useGetTypeCategoryAndTags({ 
    tagTypeProp: hasTags ? 'tags' : null, 
    enableDataFetch: hasTags 
  });

  const optionsData = useMemo(() => ({
    themes: themesQuery.status === 'success' && themesQuery.data 
      ? convertTagDocsDataToOptions(themesQuery.data, 'tags') 
      : [],
    subThemes: subThemesQuery.status === 'success' && subThemesQuery.data 
      ? convertTagDocsDataToOptions(subThemesQuery.data, 'tags') 
      : [],
    tags: tagsQuery.status === 'success' && tagsQuery.data 
      ? convertTagDocsDataToOptions(tagsQuery.data, 'tags') 
      : []
  }), [
    themesQuery.data, themesQuery.status, 
    subThemesQuery.data, subThemesQuery.status, 
    tagsQuery.data, tagsQuery.status
  ]);

  return {
    hierarchyConfig: { hasThemes, hasSubThemes, hasTags },
    optionsData,
    isLoading: {
      themes: themesQuery.status === 'loading',
      subThemes: subThemesQuery.status === 'loading',
      tags: tagsQuery.status === 'loading'
    },
  };
};
